/* paws by Ciroa · brand interaction layer over Horizon.
   Confetti on add to cart, paw cursor trail, scroll reveals, count ups, toast.
   Dependency free and defensive: if Horizon renames a class, this stops
   decorating rather than throwing. */
(function () {
  'use strict';
  var PAL = ['#B9D4F1', '#F5C4C8', '#D5B49E', '#B8DFCF', '#B3D4E8', '#435D96', '#E4685E'];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function confetti(x, y, n) {
    if (reduce) return;
    n = n || 26;
    for (var i = 0; i < n; i++) {
      var d = document.createElement('div');
      d.className = 'paws-cf';
      d.style.background = PAL[i % PAL.length];
      d.style.left = x + 'px';
      d.style.top = y + 'px';
      if (i % 3 === 0) d.style.borderRadius = '50%';
      document.body.appendChild(d);
      var ang = (Math.PI * 2 * i) / n + (i % 5) * 0.16;
      var dist = 90 + (i % 7) * 26;
      var a = d.animate([
        { transform: 'translate(-50%,-50%) scale(1) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + (Math.cos(ang) * dist - 6) + 'px,' + (Math.sin(ang) * dist + 150) + 'px) scale(.4) rotate(' + (420 + i * 23) + 'deg)', opacity: 0 }
      ], { duration: 900 + (i % 6) * 130, easing: 'cubic-bezier(.2,.7,.3,1)' });
      a.onfinish = (function (el) { return function () { el.remove(); }; })(d);
    }
  }
  window.pawsConfetti = confetti;

  function toast(text) {
    var n = document.createElement('div');
    n.className = 'paws-toast';
    n.innerHTML = '<span>🐾 ' + text + '</span>';
    document.body.appendChild(n);
    var a = n.animate([
      { opacity: 0, transform: 'translateX(-50%) translateY(-16px) scale(.9)' },
      { opacity: 1, transform: 'translateX(-50%) translateY(0) scale(1)' },
      { opacity: 1 },
      { opacity: 0, transform: 'translateX(-50%) translateY(-14px)' }
    ], { duration: 2600, easing: 'cubic-bezier(.34,1.56,.64,1)' });
    a.onfinish = function () { n.remove(); };
  }
  window.pawsToast = toast;

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('button[name="add"], .product-form__submit, .quick-add__submit, [data-paws-add]') : null;
    if (!t) return;
    var r = t.getBoundingClientRect();
    confetti(r.left + r.width / 2, r.top + r.height / 2);
  }, true);

  var TIERS = [{ n: 3, pct: 10 }, { n: 5, pct: 15 }, { n: 7, pct: 20 }];
  var lastTier = 0;
  function tierFor(count) { var t = 0; TIERS.forEach(function (x) { if (count >= x.n) t = x.pct; }); return t; }
  document.addEventListener('cart:updated', function (e) {
    try {
      var c = e.detail && e.detail.data && e.detail.data.item_count;
      if (typeof c !== 'number') return;
      var t = tierFor(c);
      if (t > lastTier) { confetti(window.innerWidth / 2, window.innerHeight - 120, 46); toast(t + '% bundle saving unlocked'); }
      lastTier = t;
    } catch (err) { /* never break the cart */ }
  });

  if (!reduce && !('ontouchstart' in window)) {
    var last = 0;
    document.addEventListener('mousemove', function (e) {
      var now = Date.now();
      if (now - last < 130) return;
      last = now;
      var p = document.createElement('div');
      p.className = 'paws-paw';
      p.textContent = '🐾';
      p.style.left = (e.clientX - 8) + 'px';
      p.style.top = (e.clientY - 8) + 'px';
      p.style.transform = 'rotate(' + (Math.random() * 90 - 45) + 'deg)';
      document.body.appendChild(p);
      requestAnimationFrame(function () { p.style.opacity = '0'; p.style.transform += ' translateY(-22px) scale(.5)'; });
      setTimeout(function () { p.remove(); }, 950);
    });
  }

  function observe() {
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(document.querySelectorAll('.paws-rv'), function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(document.querySelectorAll('.paws-rv:not(.is-in)'), function (el) { io.observe(el); });

    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var to = parseInt(el.getAttribute('data-count-to'), 10) || 0;
        var cur = 0, step = Math.max(1, Math.round(to / 34));
        var timer = setInterval(function () {
          cur += step;
          if (cur >= to) { cur = to; clearInterval(timer); }
          el.textContent = cur.toLocaleString();
        }, 22);
        cio.unobserve(el);
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(document.querySelectorAll('[data-count-to]'), function (el) { cio.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
  document.addEventListener('shopify:section:load', observe);
})();
